import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-boarding-certificate-result.actions';
import { GetBoardingCertificateResultState } from './get-boarding-certificate-result.state';

/**
 * getBoardingCertificateResult initial state
 */
export const getBoardingCertificateResultInitialState: GetBoardingCertificateResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetBoardingCertificateResult Store
 */
export const getBoardingCertificateResultReducerFeatures: ReducerTypes<
  GetBoardingCertificateResultState,
  ActionCreator[]
>[] = [
  on(actions.setGetBoardingCertificateResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetBoardingCertificateResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetBoardingCertificateResult, () => getBoardingCertificateResultInitialState),

  on(actions.cancelGetBoardingCertificateResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetBoardingCertificateResult, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(
    actions.setGetBoardingCertificateResultFromApi,
    actions.updateGetBoardingCertificateResultFromApi,
    (state, payload) => asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetBoardingCertificateResult Store reducer
 */
export const getBoardingCertificateResultReducer = createReducer(
  getBoardingCertificateResultInitialState,
  ...getBoardingCertificateResultReducerFeatures
);
